<div class="container my-5">
  <mat-icon class="icon mb-3"> help-outline </mat-icon>
  <p class="text mat-h3 text-center fw-bold">
    Sie haben noch keine <ng-content></ng-content>
  </p>
</div>
